export default __webpack_public_path__ + "static/media/logo_header.76b09729.svg";